export const postData = (data, url, callback) => {
  const xhttp = new XMLHttpRequest();
  xhttp.withCredentials = true;
  xhttp.onreadystatechange = function () {
    if (this.readyState === 4) callback(this);
  };
  xhttp.open("POST", url, true);
  xhttp.setRequestHeader("Content-type", "application/json");
  xhttp.send(JSON.stringify(data));
};

export const updateData = (updates, url, callback) => {
  const xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function () {
    if (this.readyState === 4) callback(this);
  };
  xhttp.open("PUT", url, true);
  xhttp.setRequestHeader("Content-type", "application/json");
  xhttp.withCredentials = true;
  xhttp.send(JSON.stringify(updates));
};

export const deleteData = (todelete, url, callback) => {
  const xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function () {
    if (this.readyState === 4) callback(this);
  };
  xhttp.open("DELETE", url, true);
  xhttp.setRequestHeader("Content-type", "application/json");
  xhttp.withCredentials = true;
  xhttp.send(JSON.stringify(todelete));
};

export const patchData = (data, url, callback) => {
  const xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function () {
    if (this.readyState === 4) callback(this);
  };
  xhttp.open("PATCH", url, true);
  xhttp.setRequestHeader("Content-type", "application/json");
  xhttp.withCredentials = true;
  xhttp.send(JSON.stringify(data));
};

export const fetchData = (url, callback) => {
  const xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function () {
    if (this.readyState === 4) callback(this);
  };

  xhttp.open("GET", url, true);
  xhttp.withCredentials = true;
  xhttp.setRequestHeader("Content-type", "application/json");
  xhttp.send();
};

export const formPost = (key, data, files, url, callback) => {
  const formData = new FormData();
  formData.append(key || "data", JSON.stringify(data));
  files.forEach((file) => {
    formData.append("files", file, file.name);
  });
  const xhttp = new XMLHttpRequest();
  xhttp.withCredentials = true;
  xhttp.onreadystatechange = function () {
    if (this.readyState === 4) callback(this);
  };
  xhttp.open("POST", url, true);
  xhttp.send(formData);
};

export const jsonFormPost = (data, files, url, callback) => {
  const formData = new FormData();
  Object.keys(data).forEach(dt => {
    formData.append(dt, data[dt]);
  })
  files.forEach((file) => {
    formData.append(file.name, file);
  });
  const xhttp = new XMLHttpRequest();
  xhttp.withCredentials = true;
  xhttp.onreadystatechange = function () {
    if (this.readyState === 4) callback(this);
  };
  xhttp.open("POST", url, true);
  xhttp.send(formData);
};

export const formPatch = (data, files, url, callback) => {
  const formData = new FormData();
  formData.append("data", JSON.stringify(data));
  files.forEach((file) => {
    formData.append("files", file);
  });
  const xhttp = new XMLHttpRequest();
  xhttp.withCredentials = true;
  xhttp.onreadystatechange = function () {
    if (this.readyState === 4) callback(this);
  };
  xhttp.open("PATCH", url, true);
  xhttp.send(formData);
};
